try {
    const cross = document.querySelector(".cross");
    cross.addEventListener("click", (event) => {
        document.getElementById("marketing-banner").style.display = "none";
    });
    }
    catch (e) {
      console.log(e)
    }